export default "__VITE_ASSET__je04NcPW__"